module.exports = "https://static.energy5.com/_next/static/images/brand2-444bdf7caaca6e113b861c08b44ba746.webp";